import React from 'react'
import { Card, CardBody, CardHeader, Col } from 'reactstrap'
import { H4, LI, UL } from '../../../../AbstractElements'
import { OverviewGrowthTitle } from '../../../../Utils/Constants'
import ReactApexChart from 'react-apexcharts'
import { revenueChart } from '../../../../Data/DashboardsData/DefaultData'

export default function TotalRevenue() {
    return (
        <Col xl={5} md={6} className="box-col-6">
            <Card className="total-revenue">
                <CardHeader className="pb-0">
                    <div className="header-top">
                        <H4>{OverviewGrowthTitle}</H4>
                    </div>
                </CardHeader>
                <CardBody className="position-relative p-0">
                    <div className="revenue-legend">
                        <UL className='simple-list flex-row'>
                            <LI className="me-2">
                                <div className="circle bg-primary me-1"> </div><span>Earning</span>
                            </LI>
                            <LI>
                                <div className="circle bg-secondary me-1"></div><span>Expense </span>
                            </LI>
                        </UL>
                    </div>
                    <div className="revenue-chart" id="revenue-chart">
                        <ReactApexChart type='bar' options={revenueChart} series={revenueChart.series} height={330} />
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}